import BdoMerchantA from './pages/BdoMerchantA.vue';
import BdoMerchantB from './pages/BdoMerchantB.vue';
import ChangePassword from './pages/ChangePassword.vue';
import ChangePasswordDone from './pages/ChangePasswordDone.vue';
import CheckMidProcess from './pages/CheckMidProcess.vue';
import CheckMidProcessStatus from './pages/CheckMidProcessStatus.vue';
import CheckStatus from './pages/CheckStatus.vue';
import CheckYourEmail from './pages/CheckYourEmail.vue';
import ChooseMerchantType from './pages/ChooseMerchantType.vue';
import CorporationA from './pages/CorporationA.vue';
import CorporationB from './pages/CorporationB.vue';
import CorporationC from './pages/CorporationC.vue';
import CorporationD from './pages/CorporationD.vue';
import CorporationE from './pages/CorporationE.vue';
import CorporationF from './pages/CorporationF.vue';
import CorporationG from './pages/CorporationG.vue';
import CorporationH from './pages/CorporationH.vue';
import CorporationI from './pages/CorporationI.vue';
import CorporationJ from './pages/CorporationJ.vue';
import CorporationK from './pages/CorporationK.vue';
import CorporationL from './pages/CorporationL.vue';
import CorporationM from './pages/CorporationM.vue';
import Demo from './pages/Demo.vue';
import Demo2 from './pages/Demo2.vue';
import EditBusinessInfo from './pages/EditBusinessInfo.vue';
import EditBusinessInfo2 from './pages/EditBusinessInfo2.vue';
import EditBusinessInfo3 from './pages/EditBusinessInfo3.vue';
import EditDocument from './pages/EditDocument.vue';
import EditPayment from './pages/EditPayment.vue';
import EditPersonalInfo from './pages/EditPersonalInfo.vue';
import EditPersonalInfo2 from './pages/EditPersonalInfo2.vue';
import EditSettlement from './pages/EditSettlement.vue';
import FinishProcess from './pages/FinishProcess.vue';
import ForgotEmail from './pages/ForgotEmail.vue';
import ForgotPassword from './pages/ForgotPassword.vue';
import IndividualA from './pages/IndividualA.vue';
import IndividualB from './pages/IndividualB.vue';
import IndividualC from './pages/IndividualC.vue';
import IndividualD from './pages/IndividualD.vue';
import IndividualE from './pages/IndividualE.vue';
import IndividualF from './pages/IndividualF.vue';
import IndividualG from './pages/IndividualG.vue';
import IndividualH from './pages/IndividualH.vue';
import IndividualI from './pages/IndividualI.vue';
import IndividualJ from './pages/IndividualJ.vue';
import IndividualK from './pages/IndividualK.vue';
import IndividualL from './pages/IndividualL.vue';
import IndividualM from './pages/IndividualM.vue';
import LoginOtp from './pages/LoginOtp.vue';
import NeedHelp from './pages/NeedHelp.vue';
import PartnershipA from './pages/PartnershipA.vue';
import PartnershipB from './pages/PartnershipB.vue';
import PartnershipC from './pages/PartnershipC.vue';
import PartnershipD from './pages/PartnershipD.vue';
import PartnershipE from './pages/PartnershipE.vue';
import PartnershipF from './pages/PartnershipF.vue';
import PartnershipG from './pages/PartnershipG.vue';
import PartnershipH from './pages/PartnershipH.vue';
import PartnershipI from './pages/PartnershipI.vue';
import PartnershipJ from './pages/PartnershipJ.vue';
import PartnershipK from './pages/PartnershipK.vue';
import PartnershipL from './pages/PartnershipL.vue';
import PartnershipM from './pages/PartnershipM.vue';
import SolePropA from './pages/SolePropA.vue';
import SolePropB from './pages/SolePropB.vue';
import SolePropC from './pages/SolePropC.vue';
import SolePropD from './pages/SolePropD.vue';
import SolePropE from './pages/SolePropE.vue';
import SolePropF from './pages/SolePropF.vue';
import SolePropG from './pages/SolePropG.vue';
import SolePropH from './pages/SolePropH.vue';
import SolePropI from './pages/SolePropI.vue';
import SolePropJ from './pages/SolePropJ.vue';
import SolePropK from './pages/SolePropK.vue';
import SolePropL from './pages/SolePropL.vue';
import SolePropM from './pages/SolePropM.vue';
import SolePropN from './pages/SolePropN.vue';
import VerifyOtp from './pages/VerifyOtp.vue';
import ViewPdf from './pages/ViewPdf.vue';
import WhetherBDOMerchant from './pages/WhetherBDOMerchant.vue';

export default [
{ path: '/bdo-merchant-a', name: 'BdoMerchantA', component: BdoMerchantA },
{ path: '/bdo-merchant-b', name: 'BdoMerchantB', component: BdoMerchantB },
{ path: '/change-password', name: 'ChangePassword', component: ChangePassword },
{ path: '/change-password-done', name: 'ChangePasswordDone', component: ChangePasswordDone },
{ path: '/check-mid-process', name: 'CheckMidProcess', component: CheckMidProcess },
{ path: '/check-mid-process-status', name: 'CheckMidProcessStatus', component: CheckMidProcessStatus },
{ path: '/check-status', name: 'CheckStatus', component: CheckStatus },
{ path: '/check-your-email', name: 'CheckYourEmail', component: CheckYourEmail },
{ path: '/choose-merchant-type', name: 'ChooseMerchantType', component: ChooseMerchantType },
{ path: '/corporation-a', name: 'CorporationA', component: CorporationA },
{ path: '/corporation-b', name: 'CorporationB', component: CorporationB },
{ path: '/corporation-c', name: 'CorporationC', component: CorporationC },
{ path: '/corporation-d', name: 'CorporationD', component: CorporationD },
{ path: '/corporation-e', name: 'CorporationE', component: CorporationE },
{ path: '/corporation-f', name: 'CorporationF', component: CorporationF },
{ path: '/corporation-g', name: 'CorporationG', component: CorporationG },
{ path: '/corporation-h', name: 'CorporationH', component: CorporationH },
{ path: '/corporation-i', name: 'CorporationI', component: CorporationI },
{ path: '/corporation-j', name: 'CorporationJ', component: CorporationJ },
{ path: '/corporation-k', name: 'CorporationK', component: CorporationK },
{ path: '/corporation-l', name: 'CorporationL', component: CorporationL },
{ path: '/corporation-m', name: 'CorporationM', component: CorporationM },
{ path: '/demo', name: 'Demo', component: Demo },
{ path: '/demo2', name: 'Demo2', component: Demo2 },
{ path: '/edit-business-info', name: 'EditBusinessInfo', component: EditBusinessInfo },
{ path: '/edit-business-info2', name: 'EditBusinessInfo2', component: EditBusinessInfo2 },
{ path: '/edit-business-info3', name: 'EditBusinessInfo3', component: EditBusinessInfo3 },
{ path: '/edit-document', name: 'EditDocument', component: EditDocument },
{ path: '/edit-payment', name: 'EditPayment', component: EditPayment },
{ path: '/edit-personal-info', name: 'EditPersonalInfo', component: EditPersonalInfo },
{ path: '/edit-personal-info2', name: 'EditPersonalInfo2', component: EditPersonalInfo2 },
{ path: '/edit-settlement', name: 'EditSettlement', component: EditSettlement },
{ path: '/finish-process', name: 'FinishProcess', component: FinishProcess },
{ path: '/forgot-email', name: 'ForgotEmail', component: ForgotEmail },
{ path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword },
{ path: '/individual-a', name: 'IndividualA', component: IndividualA },
{ path: '/individual-b', name: 'IndividualB', component: IndividualB },
{ path: '/individual-c', name: 'IndividualC', component: IndividualC },
{ path: '/individual-d', name: 'IndividualD', component: IndividualD },
{ path: '/individual-e', name: 'IndividualE', component: IndividualE },
{ path: '/individual-f', name: 'IndividualF', component: IndividualF },
{ path: '/individual-g', name: 'IndividualG', component: IndividualG },
{ path: '/individual-h', name: 'IndividualH', component: IndividualH },
{ path: '/individual-i', name: 'IndividualI', component: IndividualI },
{ path: '/individual-j', name: 'IndividualJ', component: IndividualJ },
{ path: '/individual-k', name: 'IndividualK', component: IndividualK },
{ path: '/individual-l', name: 'IndividualL', component: IndividualL },
{ path: '/individual-m', name: 'IndividualM', component: IndividualM },
{ path: '/login-otp', name: 'LoginOtp', component: LoginOtp },
{ path: '/need-help', name: 'NeedHelp', component: NeedHelp },
{ path: '/partnership-a', name: 'PartnershipA', component: PartnershipA },
{ path: '/partnership-b', name: 'PartnershipB', component: PartnershipB },
{ path: '/partnership-c', name: 'PartnershipC', component: PartnershipC },
{ path: '/partnership-d', name: 'PartnershipD', component: PartnershipD },
{ path: '/partnership-e', name: 'PartnershipE', component: PartnershipE },
{ path: '/partnership-f', name: 'PartnershipF', component: PartnershipF },
{ path: '/partnership-g', name: 'PartnershipG', component: PartnershipG },
{ path: '/partnership-h', name: 'PartnershipH', component: PartnershipH },
{ path: '/partnership-i', name: 'PartnershipI', component: PartnershipI },
{ path: '/partnership-j', name: 'PartnershipJ', component: PartnershipJ },
{ path: '/partnership-k', name: 'PartnershipK', component: PartnershipK },
{ path: '/partnership-l', name: 'PartnershipL', component: PartnershipL },
{ path: '/partnership-m', name: 'PartnershipM', component: PartnershipM },
{ path: '/sole-prop-a', name: 'SolePropA', component: SolePropA },
{ path: '/sole-prop-b', name: 'SolePropB', component: SolePropB },
{ path: '/sole-prop-c', name: 'SolePropC', component: SolePropC },
{ path: '/sole-prop-d', name: 'SolePropD', component: SolePropD },
{ path: '/sole-prop-e', name: 'SolePropE', component: SolePropE },
{ path: '/sole-prop-f', name: 'SolePropF', component: SolePropF },
{ path: '/sole-prop-g', name: 'SolePropG', component: SolePropG },
{ path: '/sole-prop-h', name: 'SolePropH', component: SolePropH },
{ path: '/sole-prop-i', name: 'SolePropI', component: SolePropI },
{ path: '/sole-prop-j', name: 'SolePropJ', component: SolePropJ },
{ path: '/sole-prop-k', name: 'SolePropK', component: SolePropK },
{ path: '/sole-prop-l', name: 'SolePropL', component: SolePropL },
{ path: '/sole-prop-m', name: 'SolePropM', component: SolePropM },
{ path: '/sole-prop-n', name: 'SolePropN', component: SolePropN },
{ path: '/verify-otp', name: 'VerifyOtp', component: VerifyOtp },
{ path: '/view-pdf', name: 'ViewPdf', component: ViewPdf },
{ path: '/whether-bdo-merchant', name: 'WhetherBDOMerchant', component: WhetherBDOMerchant },
];
